class a {
  async share({ url: n, title: e, files: r }) {
    return navigator.canShare({ url: n, title: e, files: r }) ? (await navigator.share({ url: n, title: e, files: r }), !0) : !1;
  }
  async isOnline() {
    return navigator.onLine;
  }
  suscribeOnline(n) {
    const e = () => n(navigator.onLine);
    return window.addEventListener("online", e), window.addEventListener("offline", e), () => {
      window.removeEventListener("online", e), window.removeEventListener("offline", e);
    };
  }
  getLocale() {
    return navigator.language.split("-").shift() || "en";
  }
}
const i = new a(), s = i.share, o = i.isOnline, c = i.suscribeOnline, l = i.getLocale;
export {
  i as Device,
  l as getLocale,
  o as isOnline,
  s as share,
  c as suscribeOnline
};
